import React, { useRef, useLayoutEffect, useState } from 'react'
import { Field, reduxForm } from 'redux-form'
import * as ReactBootstrap from 'react-bootstrap'
import { SignaturePadField } from '../../../components'

import { FormButtons, validations } from '../../../components'

let SignatureForm = ({ handleSubmit, pristine, reset, submitting }) => {
  const targetRef = useRef()
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 })

  useLayoutEffect(() => {
    if (targetRef.current) {
      setDimensions({
        width: targetRef.current.offsetWidth,
        height: targetRef.current.offsetHeight,
      })
    }
  }, [])

  return (
    <form onSubmit={handleSubmit}>
      <ReactBootstrap.Row ref={targetRef}>
        <ReactBootstrap.Col md={6} xs={12} lg={6}>
          <ReactBootstrap.Card>
            <ReactBootstrap.Card.Body className="p-0">
              <Field
                component={SignaturePadField}
                validate={[validations.required]}
                height="500"
                width={dimensions.width}
                name="signature"
                label="Signature"
              ></Field>
            </ReactBootstrap.Card.Body>
          </ReactBootstrap.Card>
        </ReactBootstrap.Col>
      </ReactBootstrap.Row>
      <FormButtons submitting={submitting} pristine={pristine} reset={reset} />
    </form>
  )
}
SignatureForm = reduxForm({
  form: 'SignatureForm',
})(SignatureForm)

export default SignatureForm
